import { PreferenceSection, PreferenceSummary } from 'components/Settings';
import { useTranslation } from 'react-i18next';
import { isInlineCommentsSettingsDefault } from 'utils/helper';
import { usePreferenceSettings } from '../../Preferences';
import { getInlineCommentsSummaryItems, getPreferenceInstructions } from '../preferenceSummary';

const InlineComments = ({ sectionId }) => {
    const { defaults, update, setInlineDialog, adminOverrideStates } = usePreferenceSettings();
    const { t } = useTranslation('assignment');
    const settings = defaults.inlineCommentsSettings;
    const additionalInstructions = getPreferenceInstructions(defaults.inlineCommentsCustomContext);
    return (
        <PreferenceSection
            id={sectionId}
            title={t('inline-comments-section.title', 'Inline Comments')}
            description={t(
                'inline-comments-section.inline-comments-description',
                'Inline comments provide contextual insights directly on student work.'
            )}
            toggleLabel={t(
                'inline-comments-section.automatically-generate-inline-comments',
                'Automatically Generate Inline Comments'
            )}
            toggleDescription={t(
                'inline-comments-section.inline-comments-description',
                'Inline comments provide contextual insights directly on student work.'
            )}
            enabled={defaults.aiInlineCommentsEnabled}
            adminOverrideState={adminOverrideStates[sectionId]}
            disabled={false}
            onToggle={(value) => update('aiInlineCommentsEnabled', value)}
        >
            <PreferenceSummary
                actionLabel={t('common:controls.change-settings', 'Change Settings')}
                defaultLabel={t('common:ui.default', 'Default')}
                isDefault={isInlineCommentsSettingsDefault(settings) && !additionalInstructions}
                items={getInlineCommentsSummaryItems(settings, additionalInstructions, t)}
                onAction={() => setInlineDialog(true)}
                title={t('inline-comments-section.inline-comments-settings', 'Inline Comments Settings')}
            />
        </PreferenceSection>
    );
};

export default InlineComments;
